import React ,{ Component } from 'react';
import PropTypes from 'prop-types';
import 'swiper/dist/css/swiper.min.css';
import DefaultSwiper from 'swiper/dist/js/swiper.min.js';
import isMobile from 'is-mobile';
import arrow from '../../assets/imgs/carousel-arrow.png'

import './Carousel.scss';

export default class Carousel extends Component {
  static propTypes = {
    onSlideChange: PropTypes.func
  }

  static defaultProps = {
    onSlideChange: () => {}
  }

  swiper = null;

  componentDidMount() {
    const { onSlideChange, index } = this.props;

    const swiperElement = '.swiper-container';
    const swiperSettings = {
      direction: 'horizontal',
      loop: true,
      centeredSlides: true,
      grabCursor: true,
      slidesPerView: 13,
      slideToClickedSlide: true,
      effect: 'coverflow',
      noSwiping: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 0,
        slideShadows: false,
      },
      breakpoints: {
        /* view <= 786 */
        786: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        1280: {
          slidesPerView: 8,
          spaceBetween: 20
        },
      },
      on: {
        init() {
          onSlideChange(0)
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    }

    this.swiper = new DefaultSwiper(swiperElement , swiperSettings);

    this.swiper.on('slideChange', () => {
      onSlideChange(this.swiper.realIndex);
    });

    if (index || index === 0) {
      this.swiper.slideToLoop(index);
    }
  }

  wrapElementWithSlide = element => <div className="swiper-slide">{element}</div>

  render() {
    const { children } = this.props;
    const clonedChildren = React.Children.map(children, child => React.cloneElement(this.wrapElementWithSlide(child)));

    return (
      <div className={`swiper-container ${isMobile() ? 'swiper-no-swiping' : null }`}>
        <div className="swiper-side swiper-side--left" />
        <div className="swiper-wrapper">
          {clonedChildren}
        </div>
        {isMobile() && <div className="swiper-button-next" style={{ transform: 'rotate(180deg)', backgroundImage: `url(${arrow})`, marginRight: '20px' }}/> }
        {isMobile() && <div className="swiper-button-prev" style={{ backgroundImage: `url(${arrow})` ,marginLeft: '20px' }}/> }
        <div className="swiper-side swiper-side--right" />
      </div>
    )
  }
}
